module.exports = __webpack_public_path__ + "static/media/move.81eeefc1.jpg";